import React, { useEffect, useContext, useState } from "react";
import Grid from "@mui/material/Grid2";


export default function HeroAlt({ title }) {
  return (
    <section>
       <Grid
          className="hero-alt-cover"
          size={12}
          container
        >
        <Grid className="page-tagline" size={12} container>
          <h1>{title}</h1>
        </Grid>
      </Grid>
    </section>
  );
}